import React, { useEffect } from "react";

const TrackingWidget = ({ data }) => {
    const { metaData, memberTrackingId, pageUrl } = data;

    useEffect(() => {
        window.CsnInsights = window.CsnInsights || {};
        window.CsnInsights.metaData = metaData ?? {};
        window.CsnInsights.memberTrackingId = memberTrackingId;
        window.CsnInsights.fireOnLoad = false;

        if (window.CsnInsightsEventTracker) {
            window.CsnInsightsEventTracker.sendPageView(
                window.CsnInsights.metaData,
                pageUrl
            );
        }
    }, []);

    return <></>;
};

export default TrackingWidget;
